var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.scenario
    ? _c(
        "div",
        [
          _c(
            "nav",
            [
              _c(
                "router-link",
                { attrs: { to: { name: "booking" } } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", icon: "el-icon-arrow-left" } },
                    [_vm._v("Back to Booking")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.getAddonsStatus == "success"
                ? _c(
                    "el-button",
                    {
                      staticClass: "proceed",
                      attrs: {
                        type: "success",
                        loading: _vm.updateOrderStatus == "pending"
                      },
                      on: { click: _vm.proceed }
                    },
                    [
                      _vm._v("Next Step "),
                      _c("i", { staticClass: "el-icon-arrow-right" })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("el-container", [
            _c(
              "main",
              [
                _vm.error
                  ? _c("el-alert", {
                      attrs: { title: _vm.error, type: "error" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.scenario.form_id
                  ? _c("bookingForm", {
                      ref: "bookingForm",
                      attrs: { scenarioId: _vm.scenario.id }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.scenario && _vm.settings.default_players_type == "combined"
                  ? _c("priceKeysForm", { attrs: { scenario: _vm.scenario } })
                  : _vm._e(),
                _vm._v(" "),
                _c("extras"),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "proceed mobile-only",
                    attrs: {
                      type: "success",
                      loading: _vm.updateOrderStatus == "pending"
                    },
                    on: { click: _vm.proceed }
                  },
                  [
                    _vm._v("Next Step "),
                    _c("i", { staticClass: "el-icon-arrow-right" })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "aside",
              [
                _c("cart", { attrs: { activeMobileSections: ["extras"] } }),
                _vm._v(" "),
                _vm.getAddonsStatus == "success"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "proceed",
                        attrs: {
                          type: "success",
                          loading: _vm.updateOrderStatus == "pending"
                        },
                        on: { click: _vm.proceed }
                      },
                      [
                        _vm._v("Next Step "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }